<template>
  <div class="content blacklist">
    <div class="header">
      <el-button type="primary" size="small" @click="dialogFormVisible = true">     添加公告</el-button>
    </div>
    <template>
      <el-table :data="tableData" border style="width: 100%" size="small">
        <el-table-column prop="sort" label="排序" width="140"></el-table-column>
        <el-table-column prop="des" label="公告内容" width="280"></el-table-column>
        <el-table-column prop="Url" label="公告链接地址" min-width="240"></el-table-column>
        <el-table-column prop="data" label="创建时间" min-width="240"></el-table-column>
        <el-table-column label="状态" width="160">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isShow"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text">编辑</el-button>
            <el-button type="text" @click="deleteRow(scope.$index, scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!--  添加公告 -->
    <el-dialog title="添加公告" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="公告内容" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="公告链接地址" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="公告排序" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="公告模块" :label-width="formLabelWidth">
          <el-select v-model="form.region" placeholder="请选择公告模块">
            <el-option label="模块一" value="shanghai"></el-option>
            <el-option label="模块二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page_id: "",
      tableData: [
        {
          imgUrl: "https://ae01.alicdn.com/kf/U632dc163d48d4d34a74088ca4c8e49b5W.png",
          sort: "1",
          name: "dsfsd电风扇",
          link: "",
          state: 1
        }
       ],
      dialogFormVisible: false,
      form: {
        name: '',
        region: '',
      },
      formLabelWidth: '120px'

    };
  },
  mounted() {
    this.page_id = this.$route.params.id;
    this.getLocalData();
  },
  methods: {
    // 获取数据
    getLocalData() {
      this.tableData = JSON.parse(localStorage.getItem("sliceList"))
    },
    // 删除行
    deleteRow(index, row) {
      console.log(index, row);
      this.tableData.splice(index, 1)
      localStorage.setItem("sliceList", JSON.stringify(this.tableData));
    },
    addSlice() {
      this.$router.push({
        path: `adAnnouncement`
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.blacklist {
  padding: 10px 25px;
  .header {
    border-bottom: 0;
    background-color: #f8f8f8;
    position: relative;
    padding-left: 24px;
    margin-bottom: 15px;
    padding: 10px 15px;
  }
  .img {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    img {
      width: 80%;
    }
  }
}
</style>

<style lang="scss">
.blacklist {
  .has-gutter > tr > th {
    color: #333;
    background-color: #f8f8f8;
  }
  .cell {
    text-align: center;
  }
}
</style>
